import { Spinner } from '../Spinner'

interface Props {
  height?: string
}

export function ChartLoadingPlaceholder({ height = '300px' }: Props) {
  return (
    <div className="flex items-center justify-center" style={{ minHeight: height }}>
      <Spinner size={50} color="gray" />
    </div>
  )
}
